import type { AxiosError } from 'axios';

type SWSApiErrorResponse = { title: string; detail?: string; status?: number };

function buildErrorMessage(errors: SWSApiErrorResponse[]) {
  const [error] = errors;
  if (typeof error.detail === 'string') {
    return `${error.title}: ${error.detail}`;
  }
  return error.title;
}

export function isAPIError(error: unknown): error is AxiosError<{
  errors: SWSApiErrorResponse[];
}> {
  // OK to temporary cast while within a type predicate
  const axiosError = error as AxiosError<{
    errors: SWSApiErrorResponse[];
  }>;
  return (
    axiosError.isAxiosError &&
    typeof axiosError.response !== 'undefined' &&
    axiosError.response.data.errors.length > 0
  );
}

export function handleApiError(unknownError: unknown) {
  if (
    isAPIError(unknownError) &&
    typeof unknownError.response !== 'undefined'
  ) {
    return new Error(buildErrorMessage(unknownError.response.data.errors));
  }
  return unknownError;
}
